<template>
  <div class="wonderful">
    <el-carousel ref="carousel" arrow="never" indicator-position="none" :interval="4000" height="580px">
      <el-carousel-item v-for="(item,i) in swiperList" :key="i">
        <ul class="hot_list">
          <li class="hot_item" v-for="(eitem,index) in item" :key="'fenye'+index" @click="exhjump(eitem)">
            <div class="hot_item_img">
              <img v-lazy="eitem.corplogo_cn" alt=""/>
            </div>
            <p class="hot_item_name">
              {{eitem.corpname_cn?eitem.corpname_cn:eitem.corpname_en}}
            </p>
          </li>
        </ul>
      </el-carousel-item>
       <div class="paging">
        <img class="paging_left" @click="turnPage(0)" v-lazy="hrefurl+'/public/icon/left.png'" alt=""/>
        <img class="paging_right" @click="turnPage(1)" v-lazy="hrefurl+'/public/icon/right.png'" alt=""/>
      </div>
    </el-carousel>
   
  </div>
</template>

<script>
import { reqListjson } from "../../../api";
export default {
  data(){
    return{
      swiperList:[]
    }
  },
  mounted(){
    this.hotRecommend()
  },
  methods:{
    async hotRecommend(){ // 热门推荐
      const response = await reqListjson()
      if (response.code==1) {
        this.dayaPaging(response.resilt)
      }
    },
    dayaPaging(arr){
      let newArr = []
       let index = -1
       arr.forEach((item,i) => {
        if (i%4==0) {
          index++
          newArr[index]=[]
          newArr[index].push(item)
        }else{
          newArr[index].push(item)
        }
      });
      this.swiperList = newArr
    },
    turnPage(falg){
      if (falg) {
        this.$refs.carousel.next()
      }else{
        this.$refs.carousel.prev()
        }
    },
    exhjump(item){// 跳转
      if (this.jump(this)) {
        this.$router.push('/exhibitor/details/'+item.id+"/"+item.ocid)
      }
    },
  }
}
</script>

<style scoped>
  .wonderful{
    position: relative;
  }
  .hot_item{
    background-color: #f2f2f2;
    margin-bottom: 6px;
    cursor: pointer;
  }
  .hot_item_img{
    box-sizing: border-box;
    padding: 16px 35px 0;
    height: 92px;
  }
  .hot_item_name{
    text-align: center;
    font-size: 14px;
    color: #666;
    line-height: 34px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hot_item:hover .hot_item_name{
    color: #008baf;
  }
  .paging{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    line-height: 52px;
    text-align: center;
    font-size: 18px;
    color: #999999;
    z-index: 9;
    width: auto;
    white-space: nowrap;
  }
  .paging>img{
    width: 20px;
    cursor: pointer;
  }
  .paging_left{
    margin-right: 3%;
  }
</style>